import type { Action } from './actions'
import { initState } from './actions'
import type {
    BurgerIngredientImageDTO,
    CategoryInfoDTO,
    FilterShortDTO,
    IngredientShortDTO,
    MarketingAnimationShortDTO,
    MenuShortDTO,
    NutritionShortDTO,
    ProductShortDTO,
    SuggestionShortDTO
} from 'shared/types/api'
import type { MenuSection } from './types'

const emptyMarketingAnimation = {
    actionColor: '',
    actionLabel: '',
    actionUrl: '',
    appRoute: '',
    displayOrder: 0,
    external: false,
    htmlContent: '',
    imageTitle: '',
    imageUrlCropped: [],
    imageUrlLandscape: [],
    imageUrlPortrait: [],
    enableVideo: false,
    audio: false,
    autoPlay: false,
    repeat: false,
    videoUrlLandscape: '',
    videoUrlPortrait: '',
    title: '',
    subtitle: ''
}

const emptyCategoryInfo = {
    categoryId: '',
    description: '',
    title: ''
}

const emptySuggestions = {
    routeId: '',
    title: '',
    products: []
}

export type State = {
    category: CategoryInfoDTO,
    description: string,
    footerNotice: MarketingAnimationShortDTO,
    sections: Array<MenuSection>,
    +menu: ?MenuShortDTO,
    noAllergens: boolean,
    allergens: Array<FilterShortDTO>,
    traces: Array<FilterShortDTO>,
    nutrition: Array<NutritionShortDTO>,
    +product: ?ProductShortDTO,
    +image: ?Array<string>,
    burgerImages: Array<BurgerIngredientImageDTO>,
    ingredients: Array<IngredientShortDTO>,
    suggestions: SuggestionShortDTO,
    title: string,
    type: string,
    error: ?any,
    networkError?: any,
    dataLoaded: ?boolean
}

const initialState: State = {
    product: null,
    sections: [],
    menu: null,
    noAllergens: false,
    allergens: [],
    traces: [],
    nutrition: [],
    title: '',
    type: 'burger',
    description: '',
    image: null,
    category: {
        ...emptyCategoryInfo
    },
    ingredients: [],
    burgerImages: [],
    footerNotice: {
        ...emptyMarketingAnimation
    },
    suggestions: {
        ...emptySuggestions
    },
    error: null,
    dataLoaded: false
}

const productPageReducer = (state: State = initialState, action: Action) => {
    switch (action.type) {
        case 'PAGE_DATA_PRODUCT_RESPONSE':
            return initState(action.data, state)
        case 'PAGE_DATA_PRODUCT_TAB_SELECTED':
        case 'PAGE_DATA_PRODUCT_ELEMENT_SELECTED':
            return {
                ...state,
                ...action.data,
                dataLoaded: true,
                networkError: undefined
            }
        case 'PAGE_DATA_PRODUCT_RESET':
            return {
                ...initialState,
                dataLoaded: true,
                networkError: undefined
            }
        case 'PAGE_DATA_PRODUCT_ERROR':
            return {
                ...state,
                error: action.error,
                networkError: undefined
            }
        case 'PAGE_API_ERROR':
            return {
                ...state,
                error: action.error,
                networkError: undefined
            }
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}

export { productPageReducer }
